import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import { gsap } from 'gsap';

import { fitBounds, getParcellaireFeatures, hideParcellaires, map, mapInitialized, showParcellaire } from './main';
import { $Elements, Animations, Classes, Elements, Events } from '../global/constants';

$Elements.document.on(Events.page.enter, () => {

	if(map) {

		if(mapInitialized) {
			initMarkers();
		}
		else {
			$Elements.document.on('map.initialized', initMarkers);
		}
	}
});

function initMarkers() {

	if(typeof map_params !== 'undefined') {

		if(map_params.parcellaires) {
			hideParcellaires();

			const colors = (map_params.colors) ? JSON.parse(map_params.colors) : '#4B7849';
			map.setPaintProperty('parcellaires', 'fill-color', colors);

			const names = JSON.parse(map_params.parcellaires);
			const bounds = new mapboxgl.LngLatBounds();

			if(Array.isArray(names) && names.length) {

				names.forEach(name => {
					const parcelle = getParcellaireFeatures(name);
					showParcellaire(name);

					if(Array.isArray(parcelle) && parcelle.length) {
						parcelle.forEach(layer => layer.geometry.coordinates[0].forEach(coordinates => bounds.extend(coordinates)));
					}
				});

				if(!bounds.isEmpty()) {

					$('.parcellaires-section').each(function() {

						const timeline = gsap.timeline({
							scrollTrigger: {
								trigger: this,
								once: true,
								start: 'top 80%',
								onEnter: async() => {

									await fitBounds(bounds, {
										pitch: 50,
										padding: 50,
										maxZoom: 16,
									});
								}
							}
						});
					});
				}
			}
		}
	}
}
